module.exports = __webpack_public_path__ + "img/b5.8f1f784c.png";